import axios from 'axios';
import apiConfig from '../../api.config';

export default function deletePaperlessDevice({ deviceUUID }) {
  const {
    host,
    URIs: { deletePaperlessDevice },
  } = apiConfig;

  const uri = `${host}${deletePaperlessDevice}`.replace(':deviceUUID', deviceUUID);

  return axios.delete(uri).then(res => res.data);
}
